import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {displayMembershipStatus, formatBusinessNumber, formatPhoneNumber} from "page/util/helpers";

import DatePicker from "react-datepicker";
import dateFormat, { masks } from "dateformat";
import 'react-datepicker/dist/react-datepicker.css';

export default function Detail() {
    const [content, setContent] = useState();

    const [handleStartDate, setHandleStartDate] = useState();
    const [handleEndDate, setHandleEndDate] = useState();
    const [handleMembership, setHandleMembership] = useState();

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const bizId = queryParams.get("userId");

    const requestData = (e) => {

        axios.get(`/admin/users/members/${bizId}`)
            .then((res) => {
                setContent(res.data);
            });
    }

    useEffect(() => {
        requestData();
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">회원관리 > 상세</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="invoice p-3 mb-3">
                                        <div className="row">
                                            <div className="col-12">
                                                <p className="lead">멤버정보</p>
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        {
                                                            content && (
                                                                <tbody>
                                                                <tr>
                                                                    <th style={{width: "120px"}}>SEQ</th>
                                                                    <td>{content.id}</td>
                                                                    <th style={{width: "120px"}}>아이디</th>
                                                                    <td>{content.extId}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>이름</th>
                                                                    <td>{content.name}</td>
                                                                    <th>이메일</th>
                                                                    <td>{content.email}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>가입일</th>
                                                                    <td>{content.createdAt}</td>
                                                                    <th>최종접속일</th>
                                                                    <td>{content.latestSignInAt}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>가입경로</th>
                                                                    <td>{content.oAuthType ?? "ALLTAX"}</td>
                                                                    <th>휴대폰</th>
                                                                    <td>{formatPhoneNumber(content.phoneNumber)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>홈택스ID</th>
                                                                    <td>{content.homeTaxId}</td>
                                                                    <th>홈택스PW</th>
                                                                    <td>{content.homeTaxPassword}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>홈택스2차<br/>인증번호</th>
                                                                    <td>{content.homeTaxRegisterNo}</td>
                                                                    <th>채널톡ID</th>
                                                                    <td>{content.channelTalkUserId}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>FCM토큰</th>
                                                                    <td colSpan={3}>{content.fcmToken}</td>
                                                                </tr>
                                                                {
                                                                    content.bizs.length > 0 && (
                                                                        <tr>
                                                                            <th>비즈정보</th>
                                                                            <td colSpan={3}>
                                                                                <table>
                                                                                    <thead>
                                                                                    <tr>
                                                                                        <td style={{borderTop: 'none'}}>사업장명</td>
                                                                                        <td style={{borderTop: 'none'}}>사업자번호</td>
                                                                                        <td style={{borderTop: 'none'}}>멤버십</td>
                                                                                        <td style={{borderTop: 'none'}}>상태</td>
                                                                                        <td style={{borderTop: 'none'}}>보기</td>
                                                                                    </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                    {
                                                                                        content.bizs && content.bizs.map( item =>
                                                                                            <tr>
                                                                                                <td>{item.name}</td>
                                                                                                <td>{formatBusinessNumber(item.number)}</td>
                                                                                                <td>{item.memberShip}</td>
                                                                                                <td>{displayMembershipStatus(item.memberShipStatus)}</td>
                                                                                                <td>
                                                                                                    <button type="button"
                                                                                                            className="btn btn-outline-info">
                                                                                                        <Link to={`/page/user/biz/detail?bizId=${item.id}`} target="_blank">보기</Link>
                                                                                                    </button>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    }
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                }
                                                                </tbody>
                                                            )
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                            {/* /.col */}
                                        </div>
                                    </div>

                                    <div className="row" style={{marginTop: '30px', marginBottom: '10px'}}>
                                        <div style={{margin: "0 auto"}}>
                                            <button type="button" className="btn btn-outline-dark"
                                                    style={{marginLeft: '10px'}}
                                                    onClick={e => navigate(-1)}>
                                                목록
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>

                </div>
            </div>
        </div>
    );
}

